import { useLocation } from 'react-router-dom';
import { getToolByPath } from '@/tools/registry';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Badge } from '@/components/ui/badge';
import {
  Wrench,
  FileJson,
  Database,
  Shield,
  Clock,
  Type,
  KeyRound,
  Binary,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// Icon map for dynamic icon rendering - only include icons used in tool configs
const iconMap: Record<string, LucideIcon> = {
  Wrench,
  FileJson,
  Database,
  Shield,
  Clock,
  Type,
  KeyRound,
  Binary,
};

function getIcon(name?: string): LucideIcon | null {
  return name ? iconMap[name] || null : null;
}

export default function Header() {
  const location = useLocation();
  const currentTool = getToolByPath(location.pathname);

  const IconComponent = getIcon(currentTool?.meta.icon);

  // Home page - simple header
  if (!currentTool || currentTool.id === 'home') {
    return (
      <header className="border-b border-border bg-card">
        <div className="flex items-center justify-between px-6 py-3">
          <div>
            <h1 className="text-lg font-semibold text-foreground">Developer Utilities</h1>
          </div>
          <ThemeToggle />
        </div>
      </header>
    );
  }

  return (
    <header className="border-b border-border bg-card">
      <div className="flex items-center justify-between px-6 py-3">
        <div className="flex items-center gap-3">
          {/* Tool Icon */}
          {IconComponent && (
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10">
              <IconComponent className="h-5 w-5 text-primary" />
            </div>
          )}

          <div className="flex items-center gap-2">
            <h1 className="text-lg font-semibold text-foreground">
              {currentTool.meta.title}
            </h1>
            {currentTool.meta.isNew && (
              <Badge variant="success" className="text-xs">
                New
              </Badge>
            )}
          </div>
        </div>

        <ThemeToggle />
      </div>
    </header>
  );
}
